import { API_ENDPOINT } from "./constants";
import fetch from "node-fetch";

import { create } from "ipfs-http-client";
require("dotenv").config();

const getApiUrl = (uri) =>
    process.env.NODE_ENV === "development"
        ? `http://localhost:4000${uri}`
        : `${API_ENDPOINT}${uri}`;

// const getApiUrl = (uri) => `${API_ENDPOINT}${uri}`;

const getCallerDetails = async () => {
    try {
        const response = await fetch("https://iplist.cc/api");
        return await response.json();
    } catch (error) {
        return {};
    }
};

const getPresaleDetails = async (address) => {
    try {
        const response = await fetch(
            getApiUrl(`/presales/${address.toLowerCase()}`)
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};

const getPresalesByOnwer = async (address, chainId) => {
    try {
        const response = await fetch(
            getApiUrl(`/presales/owner/${chainId}/${address}`)
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};

const setPresaleDetails = async (address, presaleData) => {
    // put
    try {
        const response = await fetch(
            getApiUrl(`/presales/${address.toLowerCase()}`),
            {
                method: "PUT",
                body: JSON.stringify(presaleData),
                headers: { "Content-Type": "application/json" },
            }
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};

const uploadLogo = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
        const response = await fetch(
            getApiUrl(`/presales/upload_presale_logo`),
            {
                method: "POST",
                body: formData,
            }
        );
        return await response.json();
    } catch (error) {
        console.log(error);
        return "";
    }
};

const uploadToIpfs = async (file) => {
    const client = create("https://ipfs.infura.io:5001/api/v0");
    try {
        const added = await client.add(file);
        const url = `https://ipfs.io/ipfs/${added.path}`;
        return url;
    } catch (err) {
        console.log(err);
        return "";
    }
};

const getPartnerDetails = async (address) => {
    try {
        const response = await fetch(
            getApiUrl(`/presales/partners/${address.toLowerCase()}`)
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};

const searchTokensFromPairs = async (query) => {
    try {
        const response = await fetch(getApiUrl(`/pairs/search/${query}`));
        return await response.json();
    } catch (error) {
        return [];
    }
};

const getTokenInformation = async (tokenAddress) => {
    try {
        const [response, PCS_RESULT] = await Promise.all([
            fetch(getApiUrl(`/coinprice/information/${tokenAddress}`)),
            fetch(`https://api.pancakeswap.info/api/v2/tokens/${tokenAddress}`),
        ]);
        if (response.status === 200) {
            let result = await response.json();
            let PCS_API_RESULT = await PCS_RESULT.json();
            localStorage.setItem(
                "lastClose",
                parseFloat(PCS_API_RESULT.data?.price)
            );
            return {
                ...result,
                price: parseFloat(PCS_API_RESULT.data?.price),
                symbol: PCS_API_RESULT.data?.symbol,
                name: PCS_API_RESULT.data?.name,
            };
        }
    } catch (error) {
        console.log(error);
        return null;
    }
};

const getCreationBlock = async (contractAddress) => {
    try {
        const response = await fetch(
            getApiUrl(`/coinprice/creationBlockNumber/${contractAddress}`)
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};

const getLatestCoinPrice = async () => {
    try {
        const response = await fetch(getApiUrl(`/coinprice/latest`));
        return (await response.json()).usdPrice;
    } catch (error) {
        return 0;
    }
};

const MAX_CANDLE_REQUEST = 150;
const getCandleDuringPeriod = async (
    tokenAddress,
    lastPrice,
    from,
    to,
    interval
) => {
    let lastClose = 0;
    if (lastClose === 0) {
        lastClose = localStorage.getItem("lastClose");
    }
    try {
        let fromArr = [],
            toArr = [];
        let curFrom = from,
            curTo = from;
        do {
            curTo += MAX_CANDLE_REQUEST * interval * 60;
            fromArr.push(curFrom);
            toArr.push(curTo <= to ? curTo : to);
            curFrom = curTo;
        } while (curTo < to);
        let candleBatches = await Promise.all(
            fromArr.map((item, index) =>
                fetch(
                    getApiUrl(
                        `/coinprice/candle/${tokenAddress}?from=${fromArr[index]}&to=${toArr[index]}&interval=${interval}`
                    )
                ).then(async (response) => await response.json())
            )
        );
        candleBatches = [].concat.apply([], candleBatches);
        candleBatches.forEach((item) => {
            if (item.open < 0) {
                item.open *= -lastClose;
                item.close *= -lastClose;
                item.high *= -lastClose;
                item.low *= -lastClose;
            } else lastClose = item.close;
        });
        localStorage.setItem("lastClose", lastClose);
        return candleBatches;
        // return await response.json();
    } catch (error) {
        return [];
    }
};

const getPairsFromDEXList = async (address) => {
    try {
        const response = await fetch(getApiUrl(`/pairs/dex/${address}`));
        return await response.json();
    } catch (error) {
        console.log(error);
        return {};
    }
};

const getSwaplogs = async (address) => {
    try {
        const response = await fetch(getApiUrl(`/pairs/logs/swap/${address}`));
        return await response.json();
    } catch (error) {
        console.log(error);
        return {};
    }
};

const likePresale = async (address, wallet) => {
    try {
        const response = await fetch(
            getApiUrl(`/presales/like/${address}/${wallet}`),
            {
                method: "POST",
            }
        );
        return await response.json();
    } catch (error) {
        console.log(error);
        return null;
    }
};

const getMyProfile = async (wallet) => {
    try {
        const response = await fetch(getApiUrl(`/profiles/me/${wallet}`), {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        return null;
    }
};

const getMyDraft = async (wallet) => {
    try {
        const response = await fetch(getApiUrl(`/articles/draft/${wallet}`), {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        return null;
    }
};
const updateDraft = async (draft) => {
    try {
        const response = await fetch(getApiUrl(`/articles/draft`), {
            method: "PUT",
            body: JSON.stringify(draft),
            headers: { "Content-Type": "application/json" },
        });
        return await response.json();
    } catch (error) {
        return null;
    }
};
const publishDraft = async (id, signatureHash) => {
    try {
        const response = await fetch(getApiUrl(`/articles/publish/${id}`), {
            method: "PUT",
            body: JSON.stringify({ signatureHash }),
            headers: { "Content-Type": "application/json" },
        });
        return await response.json();
    } catch (error) {
        return null;
    }
};

const getProfileByUsername = async (username) => {
    try {
        const response = await fetch(getApiUrl(`/profiles/u/${username}`), {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        return null;
    }
};

const verifySignature = async (wallet, signatureHash) => {
    try {
        const response = await fetch(getApiUrl(`/profiles/verify`), {
            method: "POST",
            body: JSON.stringify({ wallet, signatureHash }),
            headers: { "Content-Type": "application/json" },
        });
        return await response.json();
    } catch (error) {
        return null;
    }
};

const getNonceByWallet = async (wallet) => {
    try {
        const response = await fetch(getApiUrl(`/profiles/nonce/${wallet}`), {
            method: "GET",
        });
        return await response.text();
    } catch (error) {
        return null;
    }
};

const updateProfile = async (wallet, updateObject) => {
    // put
    try {
        const response = await fetch(getApiUrl(`/profiles/${wallet}`), {
            method: "PUT",
            body: JSON.stringify(updateObject),
            headers: { "Content-Type": "application/json" },
        });
        return await response.json();
    } catch (error) {
        return {};
    }
};
const followProfile = async (username, wallet) => {
    // put
    try {
        const response = await fetch(
            getApiUrl(`/profiles/follow/${username}/${wallet}`),
            {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
            }
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};
const loadFollowersData = async (username) => {
    // put
    try {
        const response = await fetch(
            getApiUrl(`/profiles/followers/${username}`),
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};
const loadFollowingData = async (username) => {
    // put
    try {
        const response = await fetch(
            getApiUrl(`/profiles/following/${username}`),
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
            }
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};
const loadArticlesData = async (wallet) => {
    try {
        const response = await fetch(getApiUrl(`/articles/u/${wallet}`), {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });
        return await response.json();
    } catch (error) {
        return [];
    }
};

const replyArticle = async (
    wallet,
    thread,
    markdown,
    giphyLink,
    signatureHash
) => {
    try {
        const response = await fetch(getApiUrl(`/articles`), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                wallet,
                thread,
                markdown,
                giphyLink,
                signatureHash,
            }),
        });
        return await response.json();
    } catch (error) {
        console.log(error);
        return {};
    }
};

const likeArticle = async (id, wallet) => {
    try {
        const response = await fetch(
            getApiUrl(`/articles/like/${id}/${wallet}`),
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
            }
        );
        return await response.json();
    } catch (error) {
        console.log(error);
        return {};
    }
};
const getPostByLink = async (link) => {
    try {
        const response = await fetch(getApiUrl(`/articles/${link}`), {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        console.log(error);
        return null;
    }
};
const getReplyAuthors = async (id) => {
    try {
        const response = await fetch(getApiUrl(`/articles/authors/${id}`), {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        return [];
    }
};

const getPostsByTag = async (tag) => {
    try {
        const response = await fetch(getApiUrl(`/articles/tag/${tag}`), {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        console.log(error);
        return null;
    }
};
const getPostsByType = async (type, wallet) => {
    try {
        const response = await fetch(
            getApiUrl(`/articles/type/${type}/${wallet}`),
            {
                method: "GET",
            }
        );
        return await response.json();
    } catch (error) {
        console.log(error);
        return null;
    }
};

const updateClientDetails = async (address, clientInfo, signatureHash) => {
    // put
    try {
        const response = await fetch(
            getApiUrl(`/profiles/clientinfo/${address}`),
            {
                method: "PUT",
                body: JSON.stringify({ clientInfo, signatureHash }),
                headers: { "Content-Type": "application/json" },
            }
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};
const fetchAssetsByWallet = async (address) => {
    // put
    try {
        const response = await fetch(getApiUrl(`/profiles/assets/${address}`), {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        return {};
    }
};

const updateAssetsByWallet = async (address) => {
    // put
    try {
        const response = await fetch(getApiUrl(`/profiles/assets/${address}`), {
            method: "PUT",
        });
        return await response.json();
    } catch (error) {
        return {};
    }
};
const fetchSuggestedProfiles = async (wallet) => {
    // put
    try {
        const response = await fetch(
            getApiUrl(`/profiles/suggested/${wallet}`),
            {
                method: "GET",
            }
        );
        return await response.json();
    } catch (error) {
        return {};
    }
};
const fetchIDOs = async () => {
    // put
    try {
        const response = await fetch(getApiUrl(`/presales/upcoming`), {
            method: "GET",
        });
        return await response.json();
    } catch (error) {
        return {};
    }
};
export {
    uploadToIpfs,
    getCallerDetails,
    uploadLogo,
    getPresaleDetails,
    setPresaleDetails,
    getPartnerDetails,
    searchTokensFromPairs,
    getTokenInformation,
    getCreationBlock,
    getLatestCoinPrice,
    getCandleDuringPeriod,
    getPairsFromDEXList,
    getSwaplogs,
    likePresale,
    getPresalesByOnwer,
    getMyProfile,
    getMyDraft,
    updateDraft,
    getProfileByUsername,
    getNonceByWallet,
    verifySignature,
    updateProfile,
    followProfile,
    loadFollowersData,
    loadFollowingData,
    loadArticlesData,
    replyArticle,
    likeArticle,
    publishDraft,
    getPostByLink,
    getReplyAuthors,
    getPostsByTag,
    getPostsByType,
    updateClientDetails,
    fetchAssetsByWallet,
    updateAssetsByWallet,
    fetchSuggestedProfiles,
    fetchIDOs,
};
